import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <polygon fillRule="evenodd" points="5.27 12 5.27 4 10.73 4 10.73 5.57 7.203 5.57 7.203 7.211 10.383 7.211 10.383 8.785 7.203 8.785 7.203 12"/>
  </svg>
);
